// extracted by mini-css-extract-plugin
module.exports = {"Tag":"Tag_Tag__MAjD2","Large":"Tag_Large__TDyGl","TagButton":"Tag_TagButton__whO0s","TagButtonActive":"Tag_TagButtonActive__x_isN"};